import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import moment from 'moment'

import {
  fetchHomepageIfNeeded,
  setSelectedSidebarNav,
  fetchSOVNetworksIfNeeded,
  fetchSOVCotentRankIfNeeded,
  fetchSOVCotentRankByScoreIfNeeded,
  setSelectedCategory,
  setSelectedMetricDate,
  logout
} from '../../actions'

import {
  makeSOVNetworksDetailsSelector,
  makeSOVContentRankDetailsSelector,
  makeSOVContentRankByScoreDetailsSelector,
  makeSOVCategorySelector
} from '../../selectors'

import SidebarComponent from '../../components/sidebar/SidebarComponent'
import DashboardComponent from '../../components/dashboard/DashboardComponent'
import Profile from '../../classes/profile'
import { LS_HOMEPAGE_KEY } from '../../constants/local_storage'
import GoogleAnalytics from '../../classes/GoogleAnalytics'

import SOVNetworks from '../../testsupport/apiresults/SovNetworks.json'
import SOVContentRank from '../../testsupport/apiresults/SovContentRank.json'
import ShareOfConversation from '../../testsupport/apiresults/ShareOfConversation.json'
import { DASHBOARD } from '../../constants/commons'

class DashboardContainer extends React.Component {
    static propTypes = {
      isAdmin: PropTypes.bool.isRequired,
      profile: Profile.PropTypes,
      history: PropTypes.object,
      match: PropTypes.object,
      homepage: PropTypes.object,
      sovNetworks: PropTypes.object,
      sovContentRank: PropTypes.object,
      sovContentRankByScore: PropTypes.object,
      logout: PropTypes.func.isRequired,
      location: PropTypes.object.isRequired,
      shortcut: PropTypes.shape({
        id: PropTypes.string.isRequired,
        expires_at: PropTypes.string.isRequired,
        target: PropTypes.string.isRequired,
        target_id: PropTypes.string.isRequired
      }),
      fetchHomepage: PropTypes.func.isRequired,
      selectedNav: PropTypes.string,
      isContentIntelligence: PropTypes.bool,
      isCatalogAnalysis: PropTypes.bool,
      isPerformanceAnalysis: PropTypes.bool,
      isAIInsights: PropTypes.bool,
      selectedSidebarNav: PropTypes.func,
      fetchSOVNetworks: PropTypes.func,
      fetchSOVCotentRank: PropTypes.func,
      fetchSOVCotentRankByScore: PropTypes.func,
      setSelectedCategory: PropTypes.func,
      setSelectedMetricDate: PropTypes.func,
      selectedCategory: PropTypes.string,
      selectedMetricDate: PropTypes.string,
      category: PropTypes.string
    }

    constructor (props) {
      super(props)
      this.state = {
        sovNetworks: {
          details: SOVNetworks,
          isFetching: false,
          error: false
        },
        sovContentRank: {
          details: SOVContentRank,
          isFetching: false,
          error: false
        },
        shareOfConversation: {
          details: ShareOfConversation,
          isFetching: false,
          error: false
        },
        contentRankDate: null
      }
    }

    componentDidMount () {
      GoogleAnalytics.trackGA(DASHBOARD, this.props.location, this.props.profile)
      const homepage = JSON.parse(localStorage.getItem(LS_HOMEPAGE_KEY))
      if (!homepage) {
        if (this.props.profile && this.props.profile.groups.length > 0) {
          const groups = this.props.profile.groups
          const groupName = groups.filter(group => group !== 'Admin')[0]
          this.props.fetchHomepage(groupName)
        }
      }
      const category = this.props.category
      const categoryDate = moment(new Date()).format('YYYY-MM-DD')
      const contentRankDate = moment(new Date()).subtract(1, 'days').format('YYYY-MM-DD') //Latest date, current date minus one
      this.fetchNetworks(category, categoryDate, contentRankDate)
    }

    componentDidUpdate (prevProps) {
      if ((prevProps.sovNetworks !== this.props.sovNetworks && this.props.sovNetworks.details && this.props.sovNetworks.details.length === 0) || (prevProps.sovContentRank !== this.props.sovContentRank && this.props.sovContentRank.details && this.props.sovContentRank.details.length === 0)) {
        //if previous day data in not available for the first time page load, then fetch day before previous day data
        const category = this.props.category
        const categoryDate = moment(new Date()).subtract(1, 'days').format('YYYY-MM-DD')
        const contentRankDate = moment(new Date()).subtract(2, 'days').format('YYYY-MM-DD') //Latest date, current date minus two
        this.fetchNetworks(category, categoryDate, contentRankDate)
      }
      if ((prevProps.sovNetworks !== this.props.sovNetworks && this.props.sovNetworks.details && this.props.sovNetworks.details.length > 0) && (prevProps.sovContentRank !== this.props.sovContentRank && this.props.sovContentRank.details && this.props.sovContentRank.details.length === 0)) {
        //if previous day data in not available for the first time page load, then fetch day before previous day data
        const category = this.props.category
        const categoryDate = moment(new Date()).subtract(1, 'days').format('YYYY-MM-DD')
        const contentRankDate = moment(new Date()).subtract(2, 'days').format('YYYY-MM-DD') //Latest date, current date minus two
        this.fetchNetworks(category, categoryDate, contentRankDate)
      }
    }

    fetchNetworks = (category, categoryDate, contentRankDate) => {
      this.setState({contentRankDate: contentRankDate})
      this.props.fetchSOVNetworks(category, categoryDate)
      this.props.fetchSOVCotentRank(category, contentRankDate, true)
      this.props.fetchSOVCotentRankByScore(category, contentRankDate, false)
      this.props.setSelectedCategory(category)
      this.props.setSelectedMetricDate(contentRankDate)
    }

    render () {
      const { profile, history, location, shortcut, selectedNav, isContentIntelligence, isCatalogAnalysis, isPerformanceAnalysis, isAIInsights, sovNetworks, sovContentRank, sovContentRankByScore, selectedCategory, setSelectedCategory, selectedMetricDate, setSelectedMetricDate, fetchSOVNetworks, fetchSOVCotentRank, fetchSOVCotentRankByScore } = this.props
      const homepage = JSON.parse(localStorage.getItem(LS_HOMEPAGE_KEY))
      const myLogout = () => this.props.logout()

      return (
        <>
          <SidebarComponent
            isAdmin={this.props.isAdmin}
            profile={profile}
            logout={myLogout}
            location={location}
            shortcut={shortcut}
            homepage={homepage ? homepage : this.props.homepage}
            selectedSidebarNav={this.props.selectedSidebarNav}
            selectedNav={selectedNav}
            isContentIntelligence={isContentIntelligence}
            isCatalogAnalysis={isCatalogAnalysis}
            isPerformanceAnalysis={isPerformanceAnalysis}
            isAIInsights={isAIInsights}
          />
          <DashboardComponent
            isAdmin={this.props.isAdmin}
            homepage={homepage ? homepage : this.props.homepage}
            history={history}
            shortcut={shortcut}
            sovNetworks={sovNetworks}
            // sovNetworks={this.state.shareOfConversation}
            sovContentRank={sovContentRank}
            // sovContentRank={this.state.sovContentRank}
            sovContentRankByScore={sovContentRankByScore}
            selectedCategory={selectedCategory}
            setSelectedCategory={setSelectedCategory}
            setSelectedMetricDate={setSelectedMetricDate}
            selectedMetricDate={selectedMetricDate}
            fetchSOVNetworks={fetchSOVNetworks}
            fetchSOVCotentRank={fetchSOVCotentRank}
            fetchSOVCotentRankByScore={fetchSOVCotentRankByScore}
            contentRankDate={this.state.contentRankDate}
          />
        </>
      )
    }
  }

  const mapStateToProps = () => {
    const categorySelector = makeSOVCategorySelector()
    const sovNetworksSelector = makeSOVNetworksDetailsSelector()
    const sovContentRankSelector = makeSOVContentRankDetailsSelector()
    const sovContentRankByScoreSelector = makeSOVContentRankByScoreDetailsSelector()
    return (state, ownProps) => {
      const isAdmin = state.user.isAdmin
      const profile = state.user.profile && new Profile(state.user.profile)
      const shortcut = ownProps.shortcut
      const homepage = state.homepage.list
      const selectedNav = state.sidebar.selectedNav
      const isContentIntelligence = state.sidebar.isContentIntelligence
      const isCatalogAnalysis = state.sidebar.isCatalogAnalysis
      const isPerformanceAnalysis = state.sidebar.isPerformanceAnalysis
      const isAIInsights = state.sidebar.isAIInsights
      const selectedCategory = state.sov && state.sov.selectedCategory ? state.sov.selectedCategory : ''
      const selectedMetricDate = state.sov && state.sov.selectedMetricDate ? state.sov.selectedMetricDate : null
      const category = categorySelector(state, ownProps)
      const sovNetworks = sovNetworksSelector(state, ownProps)
      const sovContentRank = sovContentRankSelector(state, ownProps)
      const sovContentRankByScore = sovContentRankByScoreSelector(state, ownProps)

      return {
        isAdmin,
        profile,
        homepage,
        shortcut,
        selectedNav,
        isContentIntelligence,
        isCatalogAnalysis,
        isPerformanceAnalysis,
        isAIInsights,
        sovNetworks,
        sovContentRank,
        sovContentRankByScore,
        selectedCategory,
        selectedMetricDate,
        category
      }
    }
  }

  function mapDispatchToProps () {
    return (dispatch) => {
      return {
        fetchHomepage: (groupName) => dispatch(fetchHomepageIfNeeded(groupName)),
        selectedSidebarNav: (nav) => dispatch(setSelectedSidebarNav(nav)),
        fetchSOVNetworks: (category, categoryDate) => dispatch(fetchSOVNetworksIfNeeded(category, categoryDate)),
        fetchSOVCotentRank: (category, date, thumbnail) => dispatch(fetchSOVCotentRankIfNeeded(category, date, thumbnail)),
        fetchSOVCotentRankByScore: (category, date, thumbnail) => dispatch(fetchSOVCotentRankByScoreIfNeeded(category, date, thumbnail)),
        setSelectedCategory: (category) => dispatch(setSelectedCategory(category)),
        setSelectedMetricDate: (date) => dispatch(setSelectedMetricDate(date)),
        logout: () => dispatch(logout())
      }
    }
  }

  export default connect(mapStateToProps, mapDispatchToProps)(DashboardContainer)